export const getOnboardingState = state => state.userOnboarding.get('viewedOnboarding');



/** WEBPACK FOOTER **
 ** ./src/selectors/user-onboarding-state-selectors.js
 **/